/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';

/**
 * The EventsControllerDtoEventInvitationInfosDetailResponse model module.
 * @module model/EventsControllerDtoEventInvitationInfosDetailResponse
 * @version 1.0
 */
class EventsControllerDtoEventInvitationInfosDetailResponse {
    /**
     * Constructs a new <code>EventsControllerDtoEventInvitationInfosDetailResponse</code>.
     * @alias module:model/EventsControllerDtoEventInvitationInfosDetailResponse
     */
    constructor() { 
        
        EventsControllerDtoEventInvitationInfosDetailResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventInvitationInfosDetailResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventInvitationInfosDetailResponse} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventInvitationInfosDetailResponse} The populated <code>EventsControllerDtoEventInvitationInfosDetailResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventInvitationInfosDetailResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('invNo')) {
                obj['invNo'] = ApiClient.convertToType(data['invNo'], 'Number');
            }
            if (data.hasOwnProperty('invitationLimit')) {
                obj['invitationLimit'] = ApiClient.convertToType(data['invitationLimit'], 'Number');
            }
            if (data.hasOwnProperty('regDuration')) {
                obj['regDuration'] = ApiClient.convertToType(data['regDuration'], 'Number');
            }
            if (data.hasOwnProperty('inviterPer')) {
                obj['inviterPer'] = ApiClient.convertToType(data['inviterPer'], 'Number');
            }
            if (data.hasOwnProperty('inviterXper')) {
                obj['inviterXper'] = ApiClient.convertToType(data['inviterXper'], 'Number');
            }
            if (data.hasOwnProperty('inviterItem1')) {
                obj['inviterItem1'] = ApiClient.convertToType(data['inviterItem1'], 'Number');
            }
            if (data.hasOwnProperty('inviterItem1Count')) {
                obj['inviterItem1Count'] = ApiClient.convertToType(data['inviterItem1Count'], 'Number');
            }
            if (data.hasOwnProperty('inviterItem2')) {
                obj['inviterItem2'] = ApiClient.convertToType(data['inviterItem2'], 'Number');
            }
            if (data.hasOwnProperty('inviterItem2Count')) {
                obj['inviterItem2Count'] = ApiClient.convertToType(data['inviterItem2Count'], 'Number');
            }
            if (data.hasOwnProperty('invitedPer')) {
                obj['invitedPer'] = ApiClient.convertToType(data['invitedPer'], 'Number');
            }
            if (data.hasOwnProperty('invitedXper')) {
                obj['invitedXper'] = ApiClient.convertToType(data['invitedXper'], 'Number');
            }
            if (data.hasOwnProperty('invitedItem1')) {
                obj['invitedItem1'] = ApiClient.convertToType(data['invitedItem1'], 'Number');
            }
            if (data.hasOwnProperty('invitedItem1Count')) {
                obj['invitedItem1Count'] = ApiClient.convertToType(data['invitedItem1Count'], 'Number');
            }
            if (data.hasOwnProperty('invitedItem2')) {
                obj['invitedItem2'] = ApiClient.convertToType(data['invitedItem2'], 'Number');
            }
            if (data.hasOwnProperty('invitedItem2Count')) {
                obj['invitedItem2Count'] = ApiClient.convertToType(data['invitedItem2Count'], 'Number');
            }
            if (data.hasOwnProperty('beginAt')) {
                obj['beginAt'] = ApiClient.convertToType(data['beginAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('eventType')) {
                obj['eventType'] = ApiClient.convertToType(data['eventType'], 'Number');
            }
            if (data.hasOwnProperty('xperUsed')) {
                obj['xperUsed'] = ApiClient.convertToType(data['xperUsed'], 'Number');
            }
            if (data.hasOwnProperty('perUsed')) {
                obj['perUsed'] = ApiClient.convertToType(data['perUsed'], 'Number');
            }
            if (data.hasOwnProperty('rewardLimit')) {
                obj['rewardLimit'] = ApiClient.convertToType(data['rewardLimit'], 'Number');
            }
            if (data.hasOwnProperty('rewardRatio')) {
                obj['rewardRatio'] = ApiClient.convertToType(data['rewardRatio'], 'Number');
            }
            if (data.hasOwnProperty('tokenType')) {
                obj['tokenType'] = ApiClient.convertToType(data['tokenType'], 'Number');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventInvitationInfosDetailResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventInvitationInfosDetailResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['contentsReward'] = undefined;

/**
 * @member {Number} invNo
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['invNo'] = undefined;

/**
 * @member {Number} invitationLimit
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['invitationLimit'] = undefined;

/**
 * @member {Number} regDuration
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['regDuration'] = undefined;

/**
 * @member {Number} inviterPer
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['inviterPer'] = undefined;

/**
 * @member {Number} inviterXper
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['inviterXper'] = undefined;

/**
 * @member {Number} inviterItem1
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['inviterItem1'] = undefined;

/**
 * @member {Number} inviterItem1Count
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['inviterItem1Count'] = undefined;

/**
 * @member {Number} inviterItem2
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['inviterItem2'] = undefined;

/**
 * @member {Number} inviterItem2Count
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['inviterItem2Count'] = undefined;

/**
 * @member {Number} invitedPer
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['invitedPer'] = undefined;

/**
 * @member {Number} invitedXper
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['invitedXper'] = undefined;

/**
 * @member {Number} invitedItem1
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['invitedItem1'] = undefined;

/**
 * @member {Number} invitedItem1Count
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['invitedItem1Count'] = undefined;

/**
 * @member {Number} invitedItem2
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['invitedItem2'] = undefined;

/**
 * @member {Number} invitedItem2Count
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['invitedItem2Count'] = undefined;

/**
 * @member {Date} beginAt
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['beginAt'] = undefined;

/**
 * @member {Date} endAt
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['endAt'] = undefined;

/**
 * @member {Date} createdAt
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['createdAt'] = undefined;

/**
 * @member {Number} eventType
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['eventType'] = undefined;

/**
 * @member {Number} xperUsed
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['xperUsed'] = undefined;

/**
 * @member {Number} perUsed
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['perUsed'] = undefined;

/**
 * @member {Number} rewardLimit
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['rewardLimit'] = undefined;

/**
 * @member {Number} rewardRatio
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['rewardRatio'] = undefined;

/**
 * @member {Number} tokenType
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['tokenType'] = undefined;

/**
 * @member {Boolean} enabled
 */
EventsControllerDtoEventInvitationInfosDetailResponse.prototype['enabled'] = undefined;






export default EventsControllerDtoEventInvitationInfosDetailResponse;

